/* globals EasyPost */

import Poller from 'backbone-poller';

import { setLocation } from 'utils/wrappers';

import ShipmentReports from 'app/collections/shipment_reports';
import TrackerReports from 'app/collections/tracker_reports';
import PaymentLogReports from 'app/collections/payment_log_reports';
import CashFlowReports from 'app/collections/cash_flow_reports';
import FulfillmentOrderReports from 'app/collections/fulfillment_order_reports';
import DropdownSelection from 'app/models/dropdown_selection';

import Base from 'app/views/base';
import ApiModeToggle from 'app/views/api_mode_toggle';
import LoaderView from 'app/views/loader';
import ReportDetailViewBase from 'app/views/report_detail_view_base';
import SelectorView from 'app/views/selector_view';

import DateAndTimeHeadingView from 'app/components/list/item/headings/date_and_time';
import DateRangeHeadingView from 'app/components/list/item/headings/date_range';
import { List as ListView, Heading } from 'app/components/list/list';
import ListSearchView from 'app/components/list/search';

import tmpl from './template';
import downloadReportTemplate from './download_report';

export const DownloadReportView = ReportDetailViewBase.extend({
  compiledTemplate: downloadReportTemplate,

  events: {
    'click .download-report': 'downloadReport',
  },

  initialize() {
    if (this.model.get('status') === 'new') {
      Poller.get(this.model,
        { autostart: true, delay: 3000, delayed: true, data: { mode: this.model.get('mode') } }
      );
    }
    this.addSubview('reportLoader', '#report_loader', new LoaderView({ type: 'flat' }));
  },

  context() {
    return {
      status: this.model.escape('status'),
      url: this.model.escape('url'),  // This field should not be printed/used directly, these urls expire very quickly
    };
  },
});

export const buildHeadings = () => {
  return [
    new Heading({
      subView: m => new DateAndTimeHeadingView({ model: m }),
      display: 'Created At',
      xsSize: 3,
      smSize: 4,
      wrapperClass: 'text-nowrap'
    }),
    new Heading({
      subView: m => new DateRangeHeadingView({ model: m }),
      display: 'Date Range',
      xsSize: 6,
      smSize: 5,
    }),
    new Heading({
      subView: m => new DownloadReportView({ model: m }),
      display: '',
      xsSize: 3,
      smSize: 3,
    }),
  ];
};

export default Base.extend({
  compiledTemplate: tmpl,
  className: 'reports',

  initialize({ apiMode, reportType, user }) {
    this.apiMode = apiMode;
    this.reportType = reportType;
    this.user = user;

    this.ReportCollectionClass = this.getReportCollectionClass(this.reportType);
    const objectTypeChoices = this.reportFilterList();

    this.objectTypeSelection = new DropdownSelection({
      choices: objectTypeChoices,
      initialIdx: objectTypeChoices.findIndex(i => i.option === this.reportType),
    });

    this.collection = new this.ReportCollectionClass([], { apiMode: this.apiMode });

    this.listenTo(this.objectTypeSelection, 'change', this.changeCollection);
    this.listenTo(this.collection, 'update', this.render);

    this.addSubview('apiModeToggle', '#api_mode_toggle', new ApiModeToggle({ model: this.apiMode }));
    this.addSubview('objectSelector', '#object_type_selector', new SelectorView({ model: this.objectTypeSelection }));
    this.addSubview('search', '#report_search', new ListSearchView({
      collection: this.collection, placeholder: '(ID)'
    }));
    this.addSubview('reportList', '#report_list', new ListView({
      headings: buildHeadings(),
      collection: this.collection,
      noResultsMessage: 'No reports have been purchased matching your filter set.',
    }));
  },

  reportFilterList() {
    const objectTypeChoices = [
      { option: 'shipment', readable: 'Shipments' },
      { option: 'tracker', readable: 'Trackers' },
      { option: 'payment_log', readable: 'Payment Logs' },
      { option: 'cash_flow', readable: 'Cash Flow' },
    ];

    const userACL = this.user.get('acl') || {};

    if (userACL && userACL.fulfillment) {
      objectTypeChoices.push({ option: 'fulfillment_order', readable: 'Fulfillment Orders' });
    }

    return objectTypeChoices;
  },

  changeCollection() {
    const objectType = this.objectTypeSelection.get('currentChoice').option;
    setLocation(`/account/reports/${objectType}`);
  },

  getReportCollectionClass(type) {
    return {
      shipment: ShipmentReports,
      tracker: TrackerReports,
      payment_log: PaymentLogReports,
      fulfillment_order: FulfillmentOrderReports,
      cash_flow: CashFlowReports,
    }[type];
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/reports/index.js